import { handleActions } from "redux-actions";

import {
    clearSiteGroups,
    getSiteGroups,
    getSiteGroupsSuccess,
    getSiteGroupsError,
    setSiteGroupFormDialog,
} from "modules/ConfigManager/services/SiteGroup/actions";

const initialState = {
    isLoading: false,
    count: 0,
    codes: [],
    siteGroups: [],
    createDialog: {
        startBranchCodes: [],
        attachedBranchCodes: [],
        detachedBranchCodes: [],
        initialData: null,
        isOpen: false,
        isLoading: false
    },
};

export const siteGroupReducer = handleActions(
    {
        [clearSiteGroups]: () => ({ ...initialState }),
        [getSiteGroups]: (state) => ({
            ...state,
            codes: [],
            count: 0,
            siteGroups: [],
            isLoading: true
        }),
        [getSiteGroupsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getSiteGroupsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setSiteGroupFormDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...initialState.createDialog,
                ...payload
            }
        }),
    },
    initialState
);
